/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */

import React, { useEffect, useState } from 'react'
import CustomConditionComponent, { ICustomCondition, LogicalOperators } from './CustomConditionComponent';
import { cloneDeep, isEqual } from 'lodash';
import { Icon } from '../../../globalUtils/globalIcons';
import CustomChartPopup from '../../softwareReleaseManagement/dashboard/CustomChartPopup';
import AddLogicalExpression from './AddLogicalExpression';
import { ExecutionPlan } from './ExecutionPlan';
import { CustomButtonGroup } from '../../../globalUtils/globalExports';
import './CustomConditionSidePopover.css';


export const operators = ['(',')','AND','OR'];
export const isOperator = (token: string) => operators?.includes(token);


interface CustomConditionSidePopoverProps {
    executionPlan: ExecutionPlan;
    handleUpdateExecutionPlan: Function;
    handleClose: Function;
    nodeId: string;
    level: number;
    parentNodeId: string;
    type: string;
    withinDuration: number | null;
    waitTimePeriod: number | null;
}

const CustomConditionSidePopover:React.FC<CustomConditionSidePopoverProps> = (props) => {
 
  const { executionPlan, handleUpdateExecutionPlan, handleClose, nodeId, level, parentNodeId,type, withinDuration, waitTimePeriod } = props;
  const [logicalExpression,setLogicalExpression] = useState<string | null>(null);
  const [conditions,setConditions] = useState<ICustomCondition[]>([]);
  const [showEditScreen, setShowEditScreen] = useState<boolean>(false);

  const handleConditionUpdate = (conditionLabel:string, condition: ICustomCondition) => {
    const allConditions = conditions?.map(item => item.condName === conditionLabel ? condition : item);
    setConditions(allConditions);
  }

  const updateLogicalExpression = (conditions: ICustomCondition[]) => {
    if(!conditions || conditions.length === 0)return;
    if(!logicalExpression){
        setLogicalExpression('A');
    }
    else {
        const tokens = logicalExpression?.split(' ');
        const operators = tokens?.filter(item => item === 'AND' || item === 'OR');
        conditions.forEach((condition,idx) => {
            if(idx === 0)return;
            else {
                if(idx > operators.length) {
                    operators.push('AND');
                    tokens.push('AND');
                    tokens.push(condition?.condName);
                }
                else operators[idx-1] = condition?.connective as LogicalOperators;
            }
        })
        let i = 0;
        const updatedTokens = tokens.map(token => {
            if (token === 'AND' || token === 'OR') {
                return operators[i++];
            }
            else return token;
        })

        setLogicalExpression(updatedTokens?.join(' '));
    }
  }

  const generateCondition = (conditionLabel:string,connectiveValue: LogicalOperators | null,condIdx: number)=>{
    const connective = connectiveValue;
    const condition =  {
        condName: conditionLabel,
        condIdx,
        paramId: null,
        paramLabel: null,
        paramType: null,
        paramLevel: null,
        operator: null,
        parameter1Value: null,
        parameter2Value: null,
        isParamTypeEnum: false,
        paramEnumValue: [],
        paramUnit: null,
        isParamTypeDate: false,
        isDerived: false,

        connectorType: null,
        connectorScope: null,

        arithmeticParamId: null,
        arithmeticParamLabel: null,
        arithmeticParamType: null,
        arithmeticParamLevel: null,
        arithmeticOperator:  null ,
        arithmeticParamValue: null,
        arithmeticParamUnit: null,
        arithmeticParamConnectorType: null,

        connective: connective,

        errorMessage: null,
        errorMessageSecondary: null,
        errorMessageArithmeticParam: null
    }
    return condition;
  }

  const getUsedConditions = (tokens: string[]) => new Set(tokens.filter(t => !isOperator(t)));
  const getNextConditionLabel = (tokens: string[]) => {
    const used = getUsedConditions(tokens)

    for (let i = 0; i < 26; i++) {
        const label = String.fromCharCode(65 + i)
        if (!used.has(label)) {
            return label;
        }
    }

    return null;
  }

  const addCondition = () => {
    const tokens = logicalExpression ? logicalExpression?.split(' ') : [];
    const nextCondition = getNextConditionLabel(tokens);
    if(!nextCondition)return;
    const condIdx = conditions?.length ?? 0; 
    const condition = generateCondition(nextCondition,'AND',condIdx);
    // setConditionCount(prev=>prev+1);
    setConditions(prev=>[...prev,condition]);
  }

  useEffect(()=>{
    updateLogicalExpression(conditions);
  },[conditions]);

  useEffect(()=>{
    if(nodeId) {
        const executionPlanCondition = executionPlan?.conditionBlocks?.find(item => item?.nodeId === nodeId);
        if(executionPlanCondition){
            setLogicalExpression(executionPlanCondition?.expression);
            setConditions(executionPlanCondition?.conditions);
        } 
    }
},[nodeId,executionPlan?.conditionBlocks])


  const handleUpdateLogicalExpression = (tokens: string[]) => {
    const conditionLabels = tokens?.filter(token => !operators?.includes(token));
    const connectives = tokens?.filter(token=> token === 'AND' || token === 'OR' );
    const updatedConditions:ICustomCondition[] = conditionLabels.map((label,conditionIdx) => {
        const condition = conditions?.filter(item => item?.condName === label)?.[0];
        const connective = conditionIdx == 0 ? 'AND' : connectives?.[conditionIdx - 1];
        if(!condition) {
            const data = generateCondition(label,connective,conditionIdx);
            return data;
        } 
        const data = cloneDeep(condition);
        data.condIdx = conditionIdx;
        data.connective = connective;
        return data;
    })

    // setConditionCount(conditionLabels?.length);
    setConditions(updatedConditions);
    setLogicalExpression(tokens?.join(' '))

  }

  const disableButton = () => {
    if(isEqual(conditions,executionPlan.trigger.conditions)) return true;
    if(!logicalExpression || logicalExpression?.trim() === '')return true;
    
    return conditions?.some(condition => {
        if(condition?.isDerived)return false;
        if( (!condition?.arithmeticParamId && condition?.errorMessage) || ((condition?.operator === 'between' || condition?.operator === 'notBetween')  && condition?.errorMessageSecondary) || (condition?.arithmeticParamId && condition?.errorMessageArithmeticParam)){
            return true;
        }
        else if (!condition?.paramId || !condition?.operator) return true;
        else if ((condition?.operator === 'between' || condition?.operator === 'notBetween') && (!condition?.parameter1Value || !condition?.parameter2Value)) return true;
        else if (condition?.isParamTypeEnum && (!condition?.paramEnumValue || condition?.paramEnumValue?.length === 0)) return true;
        else if (!condition?.isParamTypeEnum && !condition?.parameter1Value && (!condition?.arithmeticParamId || !condition?.arithmeticOperator || !condition?.arithmeticParamValue)) return true;
        return false;
    })
  } 


  const btnsList = [
    {
        buttonText: 'Save',
        buttonId: 'add',
        btnClassName:  disableButton() ? 'primary__btn disabled' : 'primary__btn',
        handleClick: (): void => {
                const data = cloneDeep(executionPlan);
                const executionPlanCondition = {
                    parentNodeId,
                    nodeId,
                    level,
                    conditions: conditions,
                    expression: logicalExpression,
                    type,
                    withinDuration,
                    waitTimePeriod
                }
                const conditionIdx = executionPlan?.conditionBlocks?.findIndex(condition => condition?.nodeId === nodeId);
                if(conditionIdx===-1){
                    data?.conditionBlocks?.push(executionPlanCondition);
                }else {
                    data.conditionBlocks[conditionIdx] = executionPlanCondition;
                }
                handleUpdateExecutionPlan(data);
                handleClose();
        },
        isDisabled: disableButton(),
        buttonVariant: 'filled',
    },
    {
        buttonText: 'Cancel',
        buttonId: 'cancel',
        btnClassName: 'secondary__btn',
        handleClick: (): void => {
            handleClose()
        },
        isDisabled: false,
        buttonVariant: 'outlined',
    }
  ]

  return (
    <>
        <div className='advance__rule__engine__custom__condition__side__popover__container'>
            <div className='advance__rule__engine__custom__condition__side__popover-logical-expression-container'>
                <div className='advance__rule__engine__custom__condition__side__popover-logical-expression-container-left'>
                    <div className='advance__rule__engine__custom__condition__side__popover-logical-expression-label'>
                        Logical Expression:
                    </div>
                    <div className='advance__rule__engine__custom__condition__side__popover-logical-expression-value'>
                        {logicalExpression}
                    </div>
                </div>
                <div className = 'advance__rule__engine__custom__condition__side__popover-logical-expression-value-edit'>
                    <Icon iconClassName='rms__pencil__icon' onIconClick={() => setShowEditScreen(true)}/>
                </div>
            </div>
            <div className='advance__rule__engine__custom__condition__side__popover-condition-container'>
                {
                    conditions && conditions?.length > 0 && conditions.map((condition,idx) =>
                        <CustomConditionComponent key={condition?.condName} condition={condition} handleConditionUpdate={handleConditionUpdate} position={idx} enableDerivedCondition={true}/>
                    )
                }
            </div>
            <div className='advance__rule__engine__custom__condition__side__popover-add-condition-btn'
                onClick={addCondition}
            >
                <Icon iconClassName='rms__table__dashboard__add__new__btn'/>
                <div className='advance__rule__engine__custom__condition__side__popover-add-condition-btn-label'>Conditions</div>
            </div>
        </div>
        <div className='advance__rule__engine__side__popover-footer'>
            <CustomButtonGroup
                buttonsList={btnsList}
                buttonGroupClassName='button__group__footer' 
            />
        </div>
        <CustomChartPopup 
            show={showEditScreen}       
        >
            <AddLogicalExpression handleUpdateLogicalExpression={handleUpdateLogicalExpression} handleClose = {()=>{setShowEditScreen(false)}} logicalExpression={logicalExpression} />
        </CustomChartPopup>
    </>
  )
}

export default CustomConditionSidePopover